import React, { useState, useEffect } from 'react'
import arcmIcons from '../Icons'
import Modal from '../components/core/Modal'
import NoticeBar from '../components/NoticeBar'

function HelpDocumentation () {
  const [isPro, setIsPro] = useState('')
  useEffect(() => {
    setIsPro(archm_admin.is_pro)
  }, [])
  return (
    <>
      <NoticeBar />
      <div className='wooarchive-settings__dashboard'>
        <div className='header arcm-flex-wrap arcm-flex arcm-items-center arcm-justify-between arcm-gap-2 arcm-mb-4'>
          <h4 className='arcm-text-gray-800 arcm-text-lg sm:arcm-text-xl arcm-font-bold'>
            Help & Documentaton
          </h4>

          <div className='arcm-inline-flex arcm-items-center arcm-gap-4 sm:arcm-gap-8 arcm-ml-auto'>
            {!isPro && (
              <button className='arcm-btn-bounce arcm-text-xs sm:arcm-text-sm arcm-text-[#A34AE8] arcm-font-medium arcm-inline-flex arcm-items-center arcm-gap-1'>
                <span className='icon arcm-inline-block'>
                  {arcmIcons.upgrade}
                </span>
                Upgrade Now
              </button>
            )}
          </div>
        </div>
      </div>

      <div className='help-documentation arcm-gap-6'>
        <div className='help-documentation__item arcm-h-[238px] arcm-p-4 arcm-bg-white arcm-rounded arcm-flex arcm-items-start arcm-flex-col'>
          <div className='icon-wrapper arcm-mb-4 arcm-h-[70px] arcm-w-[70px] arcm-flex arcm-items-center arcm-justify-center'>
            {arcmIcons.docummentsOne}
          </div>

          <div className='text arcm-mt-auto'>
            <h6 className='arcm-text-black arcm-text-sm arcm-font-medium arcm-mb-1.5'>
              {' '}
              Documentation
            </h6>
            <p className='arcm-text-gray-500 arcm-text-xs arcm-font-normal arcm-mb-5'>
              If you get stuck while exploring a feature, feel free to check our
              docs for a step-by-step guide
            </p>
            <a
              className='arcm-group arcm-cursor-pointer arcm-mt-auto arcm-px-4 arcm-py-2.5 arcm-bg-white arcm-rounded-lg arcm-border arcm-border-violet-700 arcm-text-violet-700 arcm-text-sm arcm-font-semibold arcm-inline-flex arcm-items-center arcm-gap-3 arcm-transition hover:arcm-bg-violet-700 hover:arcm-text-white'
              href='https://wppool.dev/docs-category/archive-master-docs/'
              target='__blank'
            >
              <span className=''>Open Docs</span>
              <span className='icon'>{arcmIcons.rightArrowTwo}</span>
            </a>
          </div>
        </div>
        <div className='help-documentation__item arcm-h-[238px] arcm-p-4 arcm-bg-white arcm-rounded arcm-flex arcm-items-start arcm-flex-col'>
          <div className='icon-wrapper arcm-mb-4 arcm-h-[70px] arcm-w-[70px] arcm-flex arcm-items-center arcm-justify-center'>
            {arcmIcons.video}
          </div>

          <div className='text arcm-mt-auto'>
            <h6 className='arcm-text-black arcm-text-sm arcm-font-medium arcm-mb-1.5'>
              Video Tutorial
            </h6>
            <p className='arcm-text-gray-500 arcm-text-xs arcm-font-normal arcm-mb-5'>
              Check the ArchiveMaster playlist to become an expert ArchiveMaster
              user
            </p>
            <a
              className='arcm-group arcm-cursor-pointer arcm-mt-auto arcm-px-4 arcm-py-2.5 arcm-bg-white arcm-rounded-lg arcm-border arcm-border-violet-700 arcm-text-violet-700 arcm-text-sm arcm-font-semibold arcm-inline-flex arcm-items-center arcm-gap-3 arcm-transition hover:arcm-bg-violet-700 hover:arcm-text-white'
              href='https://www.youtube.com/@WPPOOL/videos'
              target='__blank'
            >
              <span className=''>Watch Videos</span>
              <span className='icon'>{arcmIcons.rightArrowTwo}</span>
            </a>
          </div>
        </div>

        <div className='help-documentation__item arcm-h-[238px] arcm-p-4 arcm-bg-white arcm-rounded arcm-flex arcm-items-start arcm-flex-col'>
          <div className='icon-wrapper arcm-mb-4 arcm-h-[70px] arcm-w-[70px] arcm-flex arcm-items-center arcm-justify-center'>
            {arcmIcons.community}
          </div>

          <div className='text arcm-mt-auto'>
            <h6 className='arcm-text-black arcm-text-sm arcm-font-medium arcm-mb-1.5'>
              Community Forum
            </h6>
            <p className='arcm-text-gray-500 arcm-text-xs arcm-font-normal arcm-mb-5'>
              Did you know that there is a Facebook community for ArchiveMaster
              users like you? Feel free to join to be involved in the
              discussion.
            </p>
            <a
              className='arcm-group arcm-cursor-pointer arcm-mt-auto arcm-px-4 arcm-py-2.5 arcm-bg-white arcm-rounded-lg arcm-border arcm-border-violet-700 arcm-text-violet-700 arcm-text-sm arcm-font-semibold arcm-inline-flex arcm-items-center arcm-gap-3 arcm-transition hover:arcm-bg-violet-700 hover:arcm-text-white'
              href='https://www.facebook.com/groups/wppoolcommunity/'
              target='__blank'
            >
              <span className=''>Join Community</span>
              <span className='icon'>{arcmIcons.rightArrowTwo}</span>
            </a>
          </div>
        </div>
      </div>
    </>
  )
}

export default HelpDocumentation
